export class ChecklistQuestion {
    id: number;
    checklist_type_id: number;
    parent_id: number;
    number: string;
    question: string;
    question_type: QuestionType;
    required: boolean;
    sign_off_role_keys?: string[];
}

export enum QuestionType {
    YES_NO = 'YES_NO',
    YES_NO_ONLY = 'YES_NO_ONLY',
    YES_NO_HEADER = 'YES_NO_HEADER',
    TEXT = 'TEXT',
    HEADER = 'HEADER',
    SUB_HEADER = 'SUB_HEADER',
    SIGN_OFF = 'SIGN_OFF',
}

export enum AnswerType {
    YES = 'YES',
    NO = 'NO',
    NA = 'N/A',
}
